import { render, staticRenderFns } from "./BillingFileFolderIndex.vue?vue&type=template&id=09246824&"
import script from "./BillingFileFolderIndex.vue?vue&type=script&lang=js&"
export * from "./BillingFileFolderIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports